"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "racines": {
    "abb9f370": [{
      "hkey": "6337742b",
      "slug": "colle",
      "name": "Colle",
      "primary": true,
      "skipSearch": false
    }],
    "racines-di-dentro": [{
      "hkey": "6337742b",
      "slug": "colle",
      "name": "Colle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "523bad60": [{
      "hkey": "f6bbbbcb",
      "slug": "stanghe",
      "name": "Stanghe",
      "primary": true,
      "skipSearch": false
    }],
    "racines-di-fuori": [{
      "hkey": "f6bbbbcb",
      "slug": "stanghe",
      "name": "Stanghe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f2fc0b66": [{
      "hkey": "7e41c745",
      "slug": "racines",
      "name": "Racines",
      "primary": true,
      "skipSearch": false
    }],
    "valgiovo": [{
      "hkey": "7e41c745",
      "slug": "racines",
      "name": "Racines",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;